import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobeindesignComponent } from './simple-icons-adobeindesign.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobeindesignComponent ],
    exports:      [ SimpleIconsAdobeindesignComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobeindesignModule {}
